export var AmbientMode;
(function (AmbientMode) {
    AmbientMode[AmbientMode["SolidColor"] = 0] = "SolidColor";
    AmbientMode[AmbientMode["SphericalHarmonics"] = 1] = "SphericalHarmonics";
})(AmbientMode || (AmbientMode = {}));
